import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'

/**
 * Expected payload for POST /study/participant endpoint
 */
export interface ICreateSubject {
  subjectIdentifier: string
  age: number
  isSimpleMode: boolean
  deviceType: string
  timezone: IanaTimezone
  language: string
}

interface ICreateSubjectResponseBody extends ICreateSubject {
  accessCode: string
}

/**
 * Expected response for POST /study/participant endpoint
 */
export interface ICreateSubjectResponse extends AxiosResponse {
  data: ICreateSubjectResponseBody
}

export function createSubject(token: string, data: ICreateSubject, query?: string): Promise<ICreateSubjectResponse> {
  const url = (() => {
    if (!query) return '/study/participant'
    return `/study/participant?${query}`
  })()
  return Client.post(url, data, { ...authHeaders(token), validateStatus: () => true })
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/createSubject.ts